import React from "react";
import { IWorkflowOvertime } from "../../../../context/interfaces/IWorkflowContext";
import Dialog from "../../../../components/Dialog";
import ButtonStyles from "../../../../styles/components/ButtonStyles";
import {
    OvertimeWorkflowDetailsWrapper,
    OvertimeWorkflowDetailsHeader,
    OvertimeWorkflowDetailsBody,
    OvertimeWorkflowDetailsButtonsWrapper,
    OvertimeWorkflowDetailsTextWrapper,
} from "../../../../styles/components/OvertimeWorkflowDetails";
import { InformationIcon, UserIcon } from "../../../../components/Icons";
import StringUtils from "../../../../utils/types/StringUtils";

const { DefaultButtonLink } = ButtonStyles;

interface IModalProps {
    open: boolean;
    workflow: IWorkflowOvertime | null;
    onClose: (callback?: any) => void;
}

const OvertimeModalDetails: React.FC<IModalProps> = ({
    open,
    workflow,
    onClose,
}) => {
    const handleOnClose = () => {
        onClose();
    };
    return (
        <Dialog
            openModal={open}
            onHide={handleOnClose}
            size="lg"
            style={{
                width: "100%",
            }}
            dialogClassName="modal-90w"
        >
            <OvertimeWorkflowDetailsWrapper>
                <OvertimeWorkflowDetailsHeader>
                    <h1>Hora Letiva RE</h1>
                    <div>
                        <p>
                            <UserIcon
                                style={{
                                    fill: "#8A0538",
                                    width: "14px",
                                }}
                            />
                            {workflow?.nomeDocente}
                        </p>
                        <p>
                            <InformationIcon
                                style={{
                                    fill: "#8A0538",
                                    width: "16px",
                                }}
                            />
                            {`Matricula: ${workflow?.matriculaAdp}`}
                        </p>
                    </div>
                    <p className="overtime_information_header">
                        Visualize abaixo as informações do processo concluído
                    </p>
                </OvertimeWorkflowDetailsHeader>
                <OvertimeWorkflowDetailsBody>
                    <table>
                        <tbody>
                            <tr>
                                <td className="table_firts_column">
                                    Data da Alocação:
                                </td>
                                <td>
                                    {StringUtils.formatDateString(
                                        workflow?.dtAlocacaoCartao ?? "",
                                        "dd/MM/yyyy"
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td className="table_firts_column">
                                    Nome da Atividade:
                                </td>
                                <td>{workflow?.nomeAtividade}</td>
                            </tr>
                            <tr>
                                <td className="table_firts_column">
                                    Data de Criação do Cartão:
                                </td>
                                <td>
                                    {StringUtils.formatDateString(
                                        workflow?.dtCriacaoCartao ?? "",
                                        "dd/MM/yyyy"
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td className="table_firts_column">
                                    Hora Início/Fim:
                                </td>
                                <td>{`${workflow?.horaInicio} - ${workflow?.horaFim}`}</td>
                            </tr>
                            <tr>
                                <td className="table_firts_column">Campus:</td>
                                <td>{workflow?.campus}</td>
                            </tr>
                            <tr>
                                <td className="table_firts_column">
                                    Modalidade:
                                </td>
                                <td>
                                    {workflow?.modalidade?.modalidadeDescricao}
                                </td>
                            </tr>
                            <tr>
                                <td className="table_firts_column">Escola:</td>
                                <td>{workflow?.escola}</td>
                            </tr>
                            <tr>
                                <td className="table_firts_column">
                                    Centro de Resultado:
                                </td>
                                <td>{workflow?.centroResultado?.nome}</td>
                            </tr>
                            <tr>
                                <td className="table_firts_column">
                                    Carta de Orientação:
                                </td>
                                <td className="checkbox_wrapper">
                                    {workflow?.cartaOrientacao ? "Sim" : "Não"}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <OvertimeWorkflowDetailsTextWrapper>
                        <p>Detalhes</p>
                        <span>{workflow?.justificativa}</span>
                    </OvertimeWorkflowDetailsTextWrapper>
                    <OvertimeWorkflowDetailsButtonsWrapper>
                        <DefaultButtonLink onClick={() => handleOnClose()}>
                            Fechar
                        </DefaultButtonLink>
                    </OvertimeWorkflowDetailsButtonsWrapper>
                </OvertimeWorkflowDetailsBody>
            </OvertimeWorkflowDetailsWrapper>
        </Dialog>
    );
};

export default OvertimeModalDetails;
